import { GQLCompanySite } from '../../generated/gql';
import { alertStore } from '../alertStore';
import { systemStore } from '../system';
import { siteStore } from './siteStore';

export const setActiveSite = (activeSite?: GQLCompanySite) => {
  systemStore.reset();
  siteStore.reset();
  siteStore.update((s) => ({ ...s, activeSite: activeSite ?? null }));
  alertStore.update((s) => ({ ...s, siteIdFilter: activeSite?.id }));
};
